import { action, makeAutoObservable } from 'mobx'

import { Theme } from '@/themes/theme'
import { googleTheme } from '@/themes/googleTheme'
import { oktaTheme } from '@/themes/oktaTheme'

export const themes = {
  googleTheme,
  oktaTheme,
}

export const providersUrl = {
  google: 'google-directory',
  okta: 'okta',
}

const themeIdsMap = {
  google: 'googleTheme',
  okta: 'oktaTheme',
}

export type ThemeNames = keyof typeof themes
export type ProviderNames = keyof typeof providersUrl

const DEV_MODE = process.env.DEV_MODE === 'true'

export class AppStateStore {
  DEV_MODE = DEV_MODE || false
  rootStore
  themeId: ThemeNames
  theme: Theme
  provider: ProviderNames
  providerUrl: string

  constructor(rootStore) {
    makeAutoObservable(this)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.rootStore = rootStore
  }

  @action.bound setTheme(themeId: ThemeNames) {
    this.themeId = themeId
    this.theme = themes[themeId as ThemeNames]
  }

  @action.bound setProvider(provider: ProviderNames) {
    this.provider = provider
    this.providerUrl = providersUrl[provider]

    const themeId = themeIdsMap[provider]
    this.setTheme(themeId ? (themeId as ThemeNames) : 'googleTheme')
  }
}
